<section class="db-trial-limit-indicator">
  <div class="limit-indicator-header">
    <div class="title" [innerHTML]="'text_companyFreeTrial' | dbText: {companyName: companyInfo?.branding?.company_name}"></div>
    <div class="subtitle" [innerHTML]="(daysUntilNext() > 1 ? 'text_daysLeft_plural' : 'text_daysLeft_singular') | dbText: {days: daysUntilNext()}"></div>
  </div>
  <div class="days-left-progress">
    <div class="days-label" [innerHTML]="(freeDaysCount > 1 ? 'text_daysForFree_plural' : 'text_daysForFree_singular') | dbText: {days: freeDaysCount}"></div>
    <db-progress-bar
      size="sm"
      [state]="planPercentageLeft() < 35 ? 'danger' : 'black'"
      [progressPercent]="planPercentageLeft()">
    </db-progress-bar>
  </div>
  @if (showFreePlanMessage()) {
    <div class="days-left-message">
      <div class="title">{{ 'text_trialEndsTodayTitle' | dbText }}</div>
      <div class="subtitle" [innerHTML]="'text_secureYourSiteCredits' | dbText: {companyName: companyInfo?.branding?.company_name}"></div>
    </div>
  }
  <div class="divider"></div>
  <div class="ai-credits-container">
    <div class="header">
      <i class="db-icon db-icon-ds-ai"></i>
      <div class="title">
          {{ 'text_aiCreditsUsed' | dbText}}
      </div>
    </div>
    <div class="ai-credits-progress">
      <db-progress-bar
        size="sm"
        [state]="aiCreditsMode()"
        [progressPercent]="creditsUsedPercentage()">
      </db-progress-bar>
      <div class="ai-credits-number">
        {{ this.creditsUsed() }}/{{ this.creditsLimit() }}
      </div>
    </div>
    <div class="ai-credits-notif">
        {{ 'text_anyAiRequestCostsCredit' | dbText}}
    </div>
    @if (aiCreditsMessage().showMessage) {
      <div class="credits-message {{aiCreditsMessage().className}}">
        <div class="title">{{ aiCreditsMessage().title }}</div>
        <div class="subtitle">{{ aiCreditsMessage().subtitle }}</div>
      </div>
    }
  </div>
  <div class="actions-container">
    <div class="title" [innerHTML]="'text_secureYourSiteCredits' | dbText: {companyName: companyInfo?.branding?.company_name}"></div>
    <a class="ds-btn ds-btn-purple-blue ds-btn-max demo-button"
       (click)="onUpgrade.emit()">
      <span>{{ 'text_upgrade' | dbText }}</span>
    </a>
  </div>
</section>
